import DateFormatter from './EventListingDateFormatter';
import {
  startOfWeek,
  endOfWeek,
  areSameYear,
  areSameDay,
  areAdjacentMonths,
  areSameMonth,
} from './DateHelpers';

let rangeFormat = null;
function getRangeFormat() {
  if (rangeFormat === null) {
    const dateFormat = DateFormatter.getStandardDateFormat();

    const rangeFormats = {
      'MMMM D, YYYY': { md: 'MMM D', ymd: 'MMM D, YYYY', dy: 'D, YYYY' },
      'MMM D, YYYY': { md: 'MMM D', ymd: 'MMM D, YYYY', dy: 'D, YYYY' },
      'MMM DD, YYYY': { md: 'MMM DD', ymd: 'MMM DD, YYYY', dy: 'DD, YYYY' },
      'D MMMM YYYY': { md: 'D MMM', ymd: 'D MMM YYYY', dy: 'D MMM YYYY' },
      'D MMM YYYY': { md: 'D MMM', ymd: 'D MMM YYYY', dy: 'D MMM YYYY' },
      'DD MMM YYYY': { md: 'DD MMM', ymd: 'DD MMM YYYY', dy: 'DD MMM YYYY' },
      'DD/MM/YYYY': { md: 'DD/MM', ymd: 'DD/MM/YYYY', dy: 'DD/MM/YYYY' },
      'MM/DD/YYYY': { md: 'MM/DD', ymd: 'MM/DD/YYYY', dy: 'MM/DD/YYYY' },
      'ddd DD/MM/YYYY': { md: 'DD/MM', ymd: 'DD/MM/YYYY', dy: 'DD/MM/YYYY' },
      'ddd MM/DD/YYYY': { md: 'MM/DD', ymd: 'MM/DD/YYYY', dy: 'MM/DD/YYYY' },
      'dddd D MMM YYYY': { md: 'D MMM', ymd: 'D MMM YYYY', dy: 'D MMM YYYY' },
      'dddd D MMMM YYYY': { md: 'D MMM', ymd: 'D MMM YYYY', dy: 'D MMM YYYY' },
      'dddd DD MMM YYYY': { md: 'DD MMM', ymd: 'DD MMM YYYY', dy: 'DD MMM YYYY' },
      'dddd, MMM D, YYYY': { md: 'MMM D', ymd: 'MMM D, YYYY', dy: 'D, YYYY' },
      'dddd, MMM DD, YYYY': { md: 'MMM DD', ymd: 'MMM DD, YYYY', dy: 'DD, YYYY' },
      'dddd, MMMM D, YYYY': { md: 'MMMM D', ymd: 'MMMM D, YYYY', dy: 'D, YYYY' },
    };

    rangeFormat = rangeFormats[dateFormat];

    if (!rangeFormat) {
      console.warn(`Defaulting EventListing date range formats for dateFormat '${dateFormat}'`);
      rangeFormat = rangeFormats['MMMM D, YYYY'];
    }
  }
  return rangeFormat;
}

function getFormatsForDateRange(from, to) {
  const { ymd, md, dy } = getRangeFormat();

  if (areSameMonth(from, to)) {
    // Dec 3 – 9, 2017
    return [md, dy];
  }

  if (areSameYear(from, to) || areAdjacentMonths(from, to)) {
    // Jan 28 – Feb 3, 2018
    return [md, ymd];
  }

  // Dec 31, 2017 – Jan 6, 2018
  return [ymd, ymd];
}

function range(from, to) {
  if (areSameDay(from, to)) {
    return DateFormatter.standardDate(from);
  }

  const rangeFormats = getFormatsForDateRange(from, to);
  const { format } = DateFormatter;

  return `${format(from, rangeFormats[0])} – ${format(to, rangeFormats[1])}`;
}

function weekRange(date) {
  return range(startOfWeek(date), endOfWeek(date));
}

export default {
  range,
  weekRange,
};
